module.exports = __webpack_public_path__ + "static/img/Sachman.b62dc866.jpg";